'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/*****************
 ** WEBPACK FOOTER
 ** ../~/gatsby/~/scroll-behavior/~/dom-helpers/util/inDOM.js
 ** module id = 231
 ** module chunks = 0
 **/